function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "22",
  viewBox: "0 0 19 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "7",
  height: "22",
  rx: "3.5",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "12",
  width: "7",
  height: "22",
  rx: "3.5",
  fill: "#fff"
})));